import React, { useState, memo } from 'react'

// redux
// import { connect } from 'react-redux'

// bootstrap
import { Dropdown } from 'react-bootstrap';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// components
import CategoriesListing from './CategoriesIncludes/CategoriesListing';

function FormCategories(props) {
    const {
        formik,
        categories,
        selectedCategories,
        setSelectedCategories,
        categoriesToBeSaved,
        setCategoriesToBeSaved,
        errorInCategories,
        setErrorInCategories
    } = props

    // states
    const [editCategoriesVisibility, setEditCategoriesVisibility] = useState(false)

    // handling category selected by user
    const handleCategorySelect = (ev, cat) => {
        if (cat) {
            const isChecked = ev.target.checked
            if (isChecked) {
                const data = [
                    ...selectedCategories,
                    cat
                ]
                // categories change in component
                setSelectedCategories(data)

                // sending data back to component
                setCategoriesToBeSaved(data)

                // removing category error
                setErrorInCategories(false)
            } else {
                const filterSelectedCategories = selectedCategories.filter(item => item.category_id !== cat.category_id)
                // categories change in component
                setSelectedCategories(filterSelectedCategories)

                // sending data back to component
                setCategoriesToBeSaved(filterSelectedCategories)

                if (!categoriesToBeSaved?.length) {
                    // showing category error
                    setErrorInCategories(true)
                }
            }

        }
    }


    // unassign category change
    const hadleUnassigningCategory = (id) => {
        if (id) {
            const filterSelectedCategories = selectedCategories.filter(item => item.category_id !== id)

            const checkIsDefault = filterSelectedCategories.find(item => item.is_default)

            // if no category is set as is default
            if (checkIsDefault) {
                // categories change in component
                setSelectedCategories(filterSelectedCategories)

                // sending data back to component
                setCategoriesToBeSaved(filterSelectedCategories)
            } else {
                // SETTING THE FIRST CATEGORY AS IS DEFAULT
                if (filterSelectedCategories?.length) {
                    filterSelectedCategories[0].is_default = true
                }
                // categories change in component
                setSelectedCategories(filterSelectedCategories)

                // sending data back to component
                setCategoriesToBeSaved(filterSelectedCategories)
            }

        }
    }

    // default category change
    const handleDefaultCategoryChange = (id) => {
        if (id) {
            const filteredList = selectedCategories.map(item => {
                if (item.category_id === id) {
                    return {
                        ...item,
                        is_default: true
                    }
                }
                return {
                    ...item,
                    is_default: false
                }
            })

            // categories change in component
            setSelectedCategories(filteredList)

            // sending data back to component
            setCategoriesToBeSaved(filteredList)
        }
    }

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2" onClick={() => setEditCategoriesVisibility(false)}>
                <div className="pbb2-inner product-basic-info-column">
                    {/* heading */}
                    <p className={`box-heading st-fs-15 st-fw-600 st-text-color mb-2 ${(formik.touched.category_id && formik.errors.category_id) ? "st-text-danger" : ""}`}>
                        {
                            (editCategoriesVisibility ?? categories?.length) ? "Select Category to assing to this product" : "Categories"
                        }

                        {
                            /* form message */
                            errorInCategories && (
                                <span className="st-text-danger st-fs-13 st-fw-400 ms-2">Select atleast one category</span>
                            )
                        }
                    </p>

                    <div className="prods-cat-content position-relative" onClick={ev => ev.stopPropagation()}>
                        {
                            /* categories list */
                            editCategoriesVisibility ? (
                                <React.Fragment>
                                    {/* search */}
                                    <div className="st-form form-sm always-focus mb-1">
                                        <input type="text" className="form-control" placeholder="Search Category" />
                                    </div>

                                    {/* listing */}
                                    <div className="prods-cats-list position-absolute">
                                        <div className="pcl-inner position-relative">
                                            {
                                                categories?.length ? categories.map((item, index) => (
                                                    <CategoriesListing
                                                        key={item.category_id + index}
                                                        categoryItem={item}
                                                        selectedCategories={selectedCategories}
                                                        handleCategorySelect={(ev, cat) => handleCategorySelect(ev, cat)}
                                                    />
                                                )) : (
                                                    <div className="position-absolute h-100 w-100 p-3 d-flex align-items-center justify-content-center" style={{ top: 0, left: 0 }}>
                                                        <p className="st-text-color">No category found</p>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="btns">
                                            <button
                                                className="st-btn st-btn-gray st-btn-sm no-min-width"
                                                onClick={() => setEditCategoriesVisibility(false)}
                                            >
                                                <span>Close</span>
                                            </button>
                                        </div>
                                    </div>


                                </React.Fragment>
                            ) : (
                                // btns
                                <div className="btns">
                                    <button
                                        className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize"
                                        onClick={() => {
                                            setEditCategoriesVisibility(true)
                                        }}
                                    >
                                        <span className="round-feather-icon-outlined hoverable d-inline-flex align-items-center justify-content-center me-2">
                                            <FeatherIcon
                                                icon="plus"
                                                size="10"
                                                className="icon cursor-pointer" />
                                        </span>
                                        <span>manage categories</span>
                                    </button>
                                </div>
                            )
                        }

                        <div className="selected-categories">
                            <div className="sc-inner">
                                {
                                    selectedCategories?.length ? selectedCategories.map(item => (
                                        <div key={item.category_id} className="item d-flex align-items-center border-top border-bottom st-border-box-color">
                                            <p className="text st-text-color st-fw-600 media-body pe-2">
                                                {
                                                    item.parent_name ? (
                                                        <>
                                                            {item.parent_name}<span className="st-fw-400"> / {item.category_name}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {item.category_name}
                                                        </>
                                                    )
                                                }
                                                {
                                                    item.is_default ? (
                                                        <span className="ms-2 st-fs-12 st-text-primary">Default</span>
                                                    ) : null
                                                }
                                            </p>
                                            <Dropdown className="st-bs-dropdown no-down-icon">
                                                <Dropdown.Toggle id={item.category_id} className="st-round-btn st-btn-xs d-flex align-items-center justify-content-center p-0">
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu style={{ left: 'initial', right: 0 }}>
                                                    {
                                                        item.is_default ? (
                                                            <Dropdown.Item className="d-flex align-items-center" style={{ pointerEvents: 'none' }}>
                                                                <p className="st-text-primary">Default</p>
                                                            </Dropdown.Item>
                                                        ) : (
                                                            <Dropdown.Item onClick={() => handleDefaultCategoryChange(item.category_id)} className="d-flex align-items-center">
                                                                <p>Make it default</p>
                                                            </Dropdown.Item>
                                                        )
                                                    }
                                                    <Dropdown.Item onClick={() => hadleUnassigningCategory(item.category_id)} className="d-flex align-items-center">
                                                        <p>Unassign Category</p>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>

                                        </div>
                                    )) : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(FormCategories)